/**
 * @fileoverview Action Hits Module for InstantSearch.js.
 * Renders hits for the actions category using a custom hits widget.
 */

import { highlight } from "instantsearch.js/es/helpers";
import cleanHtml from "./HitsWidget";

/**
 * Renders action hits into the specified container.
 * This function is used as a connector for the custom hits widget in InstantSearch.js.
 * It maps over the hits data to generate the HTML content for each action hit.
 *
 * @param {Object} renderOptions - The options and utilities provided by InstantSearch.js for rendering.
 */
const ActionHits = (renderOptions) => {
    const { hits, widgetParams } = renderOptions;0
    if (Object.keys(hits).length > 0) {
        widgetParams.container.innerHTML = `
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-5">
            ${hits.map((hit) => `
                <a class="relative block" href="${hit.permalink}">
                    <div class="p-4 flex flex-col items-start justify-between relative overflow-hidden group 
                    2xl:h-[345px] xl:h-[285px] lg:h-[350px] md:h-[216px] sm:h-[270px] xs:h-[334px] max-xs:h-[334px]">
                        <div class="absolute inset-0 z-0 bg-black">
                            <img class="object-cover w-full h-full transition-transform opacity-50 duration-500 group-hover:scale-110" src="${hit.featured_image}" alt="${hit.post_title}">
                        </div>
                        <span class="relative underline text-white text-body-regular">
                            ${cleanHtml(hit.value_chain ?? '')}
                        </span>
                        <div class="text-white relative pt-3 sm:leading-[22px] lg:leading-[26px] text-heading-regular sm:text-[16px] lg:text-[19px] sm:font-medium">
                            ${highlight({attribute: 'post_title', hit})}
                        </div>
                    </div>
                </a>
            `).join('')}
        </div>
        `;
        document.getElementById("pagination").style.display = 'block';
    } else {
        widgetParams.container.innerHTML = `
            <div class="mt-4">
                <p>There are no actions that match your search.</p
            </div>
        `;
        document.getElementById("pagination").style.display = 'none';
    }
};

export default ActionHits;